import React, { memo, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import Card, { CardHeader, CardLabel, CardTitle, CardBody } from '../../../components/bootstrap/Card';

import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import { getFirstLetter } from '../../../helpers/helpers';
import { ResultsContext } from '../../../contexts/results';
import Money from '../../../helpers/utils/money/money';
import { DefaultContext } from '../../../contexts/default';

const RankingPorOperador = () => {
  const { darkModeStatus } = useDarkMode();

  const { usersDicionary } = useContext(DefaultContext)
  const { sales, dataFilter } = useContext(ResultsContext)

  const [usersSales, setusersSales] = useState([])

  useEffect(() => {
    if (usersDicionary && sales) {
      const usersDicionaryClone = structuredClone(usersDicionary)
      Object.keys(usersDicionaryClone).forEach(key => {
        usersDicionaryClone[key].total = 0
        usersDicionaryClone[key].qtd = 0
      })
      sales.forEach(sale => {
        if (!sale.reversed && usersDicionaryClone[sale.userId]) {
          usersDicionaryClone[sale.userId].total += sale.value
          usersDicionaryClone[sale.userId].qtd++
        }
      })

      const usersRank = Object.keys(usersDicionaryClone).map(key => usersDicionaryClone[key]).filter(item => item.total > 0)

      usersRank.sort((a, b) => {
        if (a.total > b.total) return -1;
        if (a.total < b.total) return 1;
        return 0;
      })

      setusersSales(usersRank)
    }
  }, [usersDicionary, sales])

  const TopSalesItem = useCallback(({ displayName, total, qtd }) => {
    return (
      <div className='col-12'>
        <div className='row'>
          <div className='col d-flex align-items-center'>
            <div className='flex-shrink-0'>
              <div className='ratio ratio-1x1 me-3' style={{ width: 48 }}>
                <div
                  className={classNames(
                    'rounded-2',
                    'd-flex align-items-center justify-content-center',
                    {
                      'bg-l10-dark': !darkModeStatus,
                      'bg-l90-dark': darkModeStatus,
                    },
                  )}>
                  <span className='fw-bold'>{getFirstLetter(displayName)}</span>
                </div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <div className='fs-6'>{displayName}</div>
              <div className='text-muted'>
                <small>Vendas</small>
              </div>
            </div>
          </div>
          <div className='col-auto text-end'>
            <div>
              <strong>{Money.centsToMaskMoney(total)}</strong>
            </div>
            <div className='text-muted'>
              <small>{qtd}</small>
            </div>
          </div>
        </div>
      </div>
    );
  }, [darkModeStatus]);

  const dataRender = useMemo(() => {
    if (dataFilter.store === '#') return usersSales;
    return usersSales.filter(item => item.storeId === dataFilter.store)
  }, [usersSales, dataFilter])


  return (
    <Card stretch>
      <CardHeader>
        <CardLabel icon='Assessment' iconColor='light'>
          <CardTitle>Ranking por Operador</CardTitle>
        </CardLabel>
      </CardHeader>
      <CardBody isScrollable>
        <div className='row g-3'>
          {dataRender.length === 0 ? <h5>Não há Ranking de operadores. Selecione corretamente os filtros!</h5> : dataRender.map((i) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <TopSalesItem key={i.id} {...i} />
          ))}
        </div>
      </CardBody>
    </Card>
  )
}

export default memo(RankingPorOperador);